import { useQuery } from '@tanstack/react-query';
import { productsApi, inventoryApi, PublicInventory } from '../services/api';

export const useProducts = (params?: {
  locationId?: string;
  category?: string;
  search?: string;
}) => {
  return useQuery({
    queryKey: ['products', params],
    queryFn: () => productsApi.getAll(params),
  });
};

export const useProductsTotal = () => {
  return useQuery({
    queryKey: ['products', 'total'],
    queryFn: () => productsApi.getTotal(),
  });
};

export const useProduct = (id: string) => {
  return useQuery({
    queryKey: ['products', id],
    queryFn: () => productsApi.getById(id),
    enabled: !!id,
  });
};

export const useProductsByLocation = (locationId: string) => {
  return useQuery({
    queryKey: ['products', 'location', locationId],
    queryFn: () => productsApi.getByLocation(locationId),
    enabled: !!locationId,
  });
};


export const useInventoryByProduct = (productId: string) => {
  return useQuery({
    queryKey: ['inventory', 'product', productId],
    queryFn: () => inventoryApi.getByProduct(productId),
    enabled: !!productId,
  });
};

export const useInventoryByLocation = (locationId: string) => {
  return useQuery<PublicInventory[]>({
    queryKey: ['inventory', 'location', locationId],
    queryFn: () => inventoryApi.getByLocation(locationId),
    enabled: !!locationId,
  });
};
